import React, { useMemo, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import PortalScreen from './screens/PortalScreen';
import CustomerDocumentUpload from './screens/CustomerDocumentUpload';
import './App.css';

const AUTH_KEY = 'vt_dashboard_authed_v1';

function App() {
  const location = useLocation();
  const isUploadPage = location.pathname === '/customer/upload';
  
  const [isAuthed, setIsAuthed] = useState(() => {
    const token = localStorage.getItem('vt_dashboard_token');
    return token !== null;
  });
  const [showRegister, setShowRegister] = useState(false);

  const onLogin = (authData) => {
    if (authData && authData.jwt) {
      localStorage.setItem('vt_dashboard_token', authData.jwt);
    }
    localStorage.setItem(AUTH_KEY, 'true');
    setIsAuthed(true);
    setShowRegister(false);
  };

  const onRegister = (authData) => {
    if (authData && authData.jwt) {
      localStorage.setItem('vt_dashboard_token', authData.jwt);
    }
    localStorage.setItem(AUTH_KEY, 'true');
    setIsAuthed(true);
    setShowRegister(false);
  };

  const onLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem('vt_dashboard_token');
    setIsAuthed(false);
  };

  const onSwitchToRegister = () => {
    setShowRegister(true);
  };

  const onSwitchToLogin = () => {
    setShowRegister(false);
  };

  const appShellClassName = useMemo(() => {
    return ['vt-app', 'vt-theme--persona'].join(' ');
  }, []);

  // Public upload page - no authentication required
  if (isUploadPage) {
    return (
      <Routes>
        <Route path="/customer/upload" element={<CustomerDocumentUpload />} />
      </Routes>
    );
  }

  // Protected dashboard routes
  return (
    <div className={appShellClassName}>
      <Routes>
        {isAuthed ? (
          <>
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/*" element={<PortalScreen onLogout={onLogout} />} />
          </>
        ) : (
          <>
            <Route 
              path="/login" 
              element={
                showRegister ? (
                  <RegisterScreen onRegister={onRegister} onSwitchToLogin={onSwitchToLogin} />
                ) : (
                  <LoginScreen onLogin={onLogin} onSwitchToRegister={onSwitchToRegister} />
                )
              } 
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;

